import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterRoutingModule } from './footer-routing.module';
import { FooterComponent } from './footer.component';
import { TooltipModule } from 'primeng/tooltip';


@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule,
    FooterRoutingModule,
    TooltipModule
  ],
  exports: [FooterComponent]
})
export class FooterModule { }
